module.exports = __webpack_public_path__ + "img/join2-4.f1667910.jpg";